/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('.l-animebtn').on('click', function() {
    $('.l-animebtn').toggleClass('active')
  })
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('.h_nav_wrap').toggleClass('active')
  })
  $('.l-animebtn').on('click', function() {
    $('body').toggleClass('active')
  })
  $('.h_ul_navbg').on('click', function() {
    $('body').toggleClass('active')
  })
  $('.back').on('click', function() {
    $('body').toggleClass('active')
  })
  $('.back').on('click', function() {
    $('.h_nav_wrap').toggleClass('active')
  })
  $('.back').on('click', function() {
    $('.l-animebtn').toggleClass('active')
  })
  $('.h_ul_navbg').on('click', function() {
    $('.h_nav_wrap').toggleClass('active')
  })
  $('.h_ul_navbg').on('click', function() {
    $('.l-animebtn').toggleClass('active')
  })
  $(window).scroll(function() {
    $('.fadein').each(function() {
      var position = $(this).offset().top //topからfadeinまでの距離を測ってポジションに代入
      var scroll = $(window).scrollTop() //スクロールした量を計測して変数に代入
      var windowHeight = $(window).height() //ウィンドウの高さを取得して代入する
      if (scroll > position - windowHeight + 150) {
        //スクロールした分＞（下から出す要素の高さ-ウィンドウの高さ）＋位置の調整
        $(this).addClass('active') //超過したときに.fadeinクラスにactiveを追加
      }
    })
  })
  if ($('.swiper-container')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('.swiper-container', {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 5000, // アニメ速度
      loop: true, // ループ
      loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      slidesPerView: 4, //表示数変更
      spaceBetween: 0, //スライド同士の間隔を空ける
      autoplay: {
        delay: 0, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      breakpoints: {
        // 指定px以下時にオプション切り替え
        768: {
          slidesPerView: 1 //表示数変更
        }
      }
    })
  }
})
